/** Mirrors Application.ContentPhotos.ContentPhotoDto and Domain.ContentPhotoOwnerType. */
export interface ContentPhotoDto {
  id: string;
  ownerType: number;
  ownerId: string;
  url: string;
  publicId: string;
  isMain: boolean;
  sortOrder: number;
  caption: string | null;
  uploadedById: string;
  uploadedByUsername: string | null;
  uploadedAt: string;
  voteCount?: number;
  currentUserVoted?: boolean;
  commentCount?: number;
}

export interface PhotoCommentDto {
  id: string;
  contentPhotoId: string;
  authorId: string;
  authorUsername: string | null;
  authorDisplayName: string | null;
  authorTier: string;
  authorScore: number;
  body: string;
  parentCommentId: string | null;
  createdAt: string;
  updatedAt: string | null;
  isDeleted: boolean;
  replies: PhotoCommentDto[];
}

export enum ContentPhotoOwnerType {
  Build = 0,
  Post = 1,
  Part = 2,
  FirearmModel = 3,
  AmmoProduct = 4,
}
